export default class ApplicationForm {
  constructor() {
    this.form = document.querySelector('.kn_apply-form .wpcf7-form'); // Contact Form 7 Formular
    if (!this.form) return;

    this.jobSelect = this.form.querySelector('select[name="dynamic-job-select"]');
    this.ortSelect = this.form.querySelector('select[name="dynamic-ort-select"]');
    this.jobTypeSelect = this.form.querySelector('select[name="dynamic-jobtype-select"]');

    this.modalElement = document.querySelector('.formFeedbackModal');
    if (this.modalElement) {
      // Import bootstrap dynamically when needed
      import('bootstrap').then(bootstrap => {
        this.formFeedbackModal = new bootstrap.Modal(this.modalElement, {});
        this.initFormFeedback();
      });
    }

    this.init();
  }

  init() {
    // Hole die aktuellen Werte aus den data-Attributen
    const currentJob = document.body.dataset.currentJob || '';
    const currentOrt = document.body.dataset.currentOrt || '';
    const currentJobType = document.body.dataset.currentJobType || '';

    // Setze die Werte in den Selects
    if (this.jobSelect) {
      this.setSelectValue(this.jobSelect, currentJob);
    }

    if (this.ortSelect) {
      this.setSelectValue(this.ortSelect, currentOrt);
    }

    if (this.jobTypeSelect) {
      this.setSelectValue(this.jobTypeSelect, currentJobType);
    }
  }

  initFormFeedback() {
    document.addEventListener('wpcf7submit', (event) => {
      const { status, message } = event.detail.apiResponse;
      const feedbackContent = document.querySelector('#formFeedbackContent');
      console.log(status === 'validation_failed' ? "Oops" : "Success", message);
      feedbackContent.innerHTML = `<div class="${status === 'validation_failed' ? 'text-danger' : 'text-success'}">${message}</div>`;
      this.formFeedbackModal.show();
    }, false);
  }

  setSelectValue(select, value) {
    if (!value) return;

    // Finde die passende Option
    const option = Array.from(select.options).find(
      option => option.value === value || option.text === value
    );

    if (option) {
      option.selected = true;
      // Trigger change event für CF7
      select.dispatchEvent(new Event('change'));
    }
  }
}
